<template>
  <div>
    <LocationsSelector
      :show-cities="true"
      :selected-locations="notification.formatted.params.locations"
      :read-only="readOnly"
      @change-locations="handleChangeLocations"
    ></LocationsSelector>

    <v-select
      :value="notification.formatted.params.hotspotTypes"
      :items="hotspotTypes"
      item-text="text"
      item-value="value"
      label="Hotspot types"
      clearable
      deletable-chips
      small-chips
      return-object
      multiple
      :disabled="readOnly"
      @change="handleChangeHotspotTypes"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @mousedown.prevent @click="selectAllHotspotTypes">
          <v-list-item-action>
            <v-icon :color="selectedHotspotTypes.length > 0 ? 'primary' : ''">
              {{ hotspotTypesAllIcon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Select All
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { getTopicsForHotspots } from "@/services/events/topics.service";

export default {
  name: "NotificationsTripwiresHotspot",
  components: {
    LocationsSelector: () => import("@/components/common/LocationsSelector"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const topics = getTopicsForHotspots();
    let hotspotTypes = [];
    if (topics) {
      hotspotTypes = topics.map((topic) => {
        return {
          text: topic.singular,
          value: topic.apiName,
        };
      });
      hotspotTypes = lodashOrderBy(hotspotTypes, ["text"], ["asc"]);
    }
    return {
      hotspotTypes: hotspotTypes,
      selectedHotspotTypes: [],
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
    hotspotTypesSelectedAll() {
      return this.selectedHotspotTypes.length === this.hotspotTypes.length;
    },
    hotspotTypesSelectedSome() {
      return (
        this.selectedHotspotTypes.length > 0 && !this.hotspotTypesSelectedAll
      );
    },
    hotspotTypesAllIcon() {
      if (this.hotspotTypesSelectedAll) {
        return "mdi-close-box";
      }
      if (this.hotspotTypesSelectedSome) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {},
  methods: {
    selectAllHotspotTypes() {
      this.$nextTick(() => {
        if (this.selectedHotspotTypes.length === this.hotspotTypes.length) {
          this.selectedHotspotTypes = [];
        } else {
          this.selectedHotspotTypes = this.hotspotTypes.slice();
        }
        this.handleChangeHotspotTypes(this.selectedHotspotTypes);
      });
    },
    handleChangeLocations(locations) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.locations = locations;
      this.update(notification);
    },
    handleChangeHotspotTypes(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.hotspotTypes = value;
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {},
};
</script>

<style scoped></style>
